import { render, staticRenderFns } from "./duoSalesMobile.vue?vue&type=template&id=b37d23c0&scoped=true&"
import script from "./duoSalesMobile.vue?vue&type=script&lang=js&"
export * from "./duoSalesMobile.vue?vue&type=script&lang=js&"
import style0 from "./duoSalesMobile.vue?vue&type=style&index=0&id=b37d23c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37d23c0",
  null
  
)

export default component.exports